<div class="page">
  <h1 class="c-h1">{{ 'MENU.recent_infos' | translate }}</h1>

  <div class="recent-infos-intro">
    <myabvv-introduction [introduction]="'RECENT_INFOS.introduction' | translate"></myabvv-introduction>
  </div>

  <myabvv-alert [condition]="isDownloading()" [message]="'USER_FEEDBACK.download_progress'" [type]="'success'"></myabvv-alert>
  <myabvv-alert [condition]="hasDownloadError()" [message]="'USER_FEEDBACK.download_error'" [type]="'error'"></myabvv-alert>

  <myabvv-unemployment-end-date></myabvv-unemployment-end-date>

  <!-- Section: Last Allowance -->
  <section class="info-section">
    <div class="info-section__header">
      <div class="info-section__icon">
        <i class="fa fa-euro-sign"></i>
      </div>
      <h3 class="info-section__title">{{ 'RECENT_INFOS.last_allowance' | translate }}</h3>
    </div>

    @if (paymentState$ | async; as paymentState) {
      @if (paymentState.loading) {
        <myabvv-loader [message]="'GENERAL.busy_loading' | translate"></myabvv-loader>
      }

      @if (paymentState.data && !paymentState.loading) {
        <div class="info-card">
          <div class="info-card__item">
            <span class="info-card__label">{{ 'ALLOWANCES.OVERVIEW.LIST.date_payment' | translate }}</span>
            <span class="info-card__value">{{ paymentState.data.dateOfPaymentDate | date:'dd/MM/yyyy' }}</span>
          </div>
          <div class="info-card__item">
            <span class="info-card__label">{{ 'ALLOWANCES.OVERVIEW.LIST.month_unemployment' | translate }}</span>
            <span class="info-card__value">{{ paymentState.data.unemploymentMonthDate | date:'MM/yyyy' }}</span>
          </div>
          <div class="info-card__item">
            <span class="info-card__label">{{ 'ALLOWANCES.OVERVIEW.LIST.document_type' | translate }}</span>
            <span class="info-card__value">
              <span class="c-doc-badge">{{ paymentState.data.raw?.mainDocumentType | uppercase }}</span>
            </span>
            <span class="info-card__subvalue">{{ getTranslatedData(paymentState.data.raw?.unemploymentTypeDescription) }}</span>
          </div>
          <div class="info-card__item">
            <span class="info-card__label">{{ 'ALLOWANCES.OVERVIEW.LIST.payout_institution' | translate }}</span>
            <span class="info-card__value">{{ getTranslatedData(paymentState.data.raw?.paymentOfficeDescription) }}</span>
          </div>
          <div class="info-card__item">
            <span class="info-card__label">{{ 'ALLOWANCES.OVERVIEW.LIST.amount_unemployment' | translate }}</span>
            <span class="info-card__value info-card__value--highlight">{{ getCurrency('E') }} {{ getUnemploymentGrossAmount(paymentState.data) }}</span>
            @if (paymentState.data.raw?.mainDocumentType !== 'C131.B') {
              <span class="info-card__subvalue">{{ getUnemploymentDays(paymentState.data) }} {{ 'FINANCIAL.days' | translate }}</span>
            }
          </div>
          <div class="info-card__item">
            <span class="info-card__label">{{ 'ALLOWANCES.OVERVIEW.LIST.additional_compensation' | translate }}</span>
            <span class="info-card__value info-card__value--highlight">{{ getCurrency('E') }} {{ getAdditionalGrossAmount(paymentState.data) }}</span>
            @if (paymentState.data.raw?.mainDocumentType !== 'C131.B') {
              <span class="info-card__subvalue">{{ getAdditionalDays(paymentState.data) }} {{ 'FINANCIAL.days' | translate }}</span>
            }
          </div>
        </div>
      }

      @if (!paymentState.data && !paymentState.loading) {
        <div class="info-card-empty">
          <i class="fa fa-inbox info-card-empty__icon"></i>
          <span>{{ 'RECENT_INFOS.no_data' | translate }}</span>
        </div>
      }

      @if (!paymentState.loading) {
        <div class="section-link">
          <a routerLink="/unemployment/payments" class="section-link__btn">
            {{ 'RECENT_INFOS.view_all_payments' | translate }}
            <i class="fa fa-arrow-right"></i>
          </a>
        </div>
      }
    }
  </section>

  <!-- Section: Last Request -->
  <section class="info-section">
    <div class="info-section__header">
      <div class="info-section__icon">
        <i class="fa fa-file-alt"></i>
      </div>
      <h3 class="info-section__title">{{ 'RECENT_INFOS.last_request' | translate }}</h3>
    </div>

    @if (requestState$ | async; as requestState) {
      @if (requestState.loading) {
        <myabvv-loader [message]="'GENERAL.busy_loading' | translate"></myabvv-loader>
      }

      @if (!requestState.loading && requestState.data?.paymentRequest; as paymentRequest) {
        <!-- Columns kept open even when empty, to stay aligned with the payment card above -->
        <div class="info-card info-card--fixed-columns">
          <div class="info-card__item">
            <span class="info-card__label">{{ 'DOCUMENTS.requests.date_hdr' | translate }}</span>
            <span class="info-card__value">{{ paymentRequest.requestDateDate | date:'dd/MM/yyyy' }}</span>
          </div>
          <div class="info-card__item">
            <span class="info-card__label">{{ 'DOCUMENTS.requests.type_hdr' | translate }}</span>
            <span class="info-card__value">{{ getRequestType(paymentRequest) }}</span>
          </div>
          <div class="info-card__item">
            <span class="info-card__label">{{ 'DOCUMENTS.requests.status_hdr' | translate }}</span>
            <span class="info-card__value">
              <span class="c-status-badge" [ngClass]="getStatusBadgeClass(paymentRequest)">
                <i class="fa c-status-badge__icon" [ngClass]="getStatusIcon(paymentRequest)"></i>
                {{ getTranslatedData(paymentRequest.raw?.requestStateDescription) }}
              </span>
            </span>
          </div>
          @if (paymentRequest.raw?.positiveDecision) {
            <div class="info-card__item">
              <span class="info-card__label">{{ 'DOCUMENTS.requests.pdf_hdr' | translate }}</span>
              <span class="info-card__value">
                <div class="c-download-btn" [class.is-disabled]="isDownloading()" role="button" tabindex="0"
                  (click)="!isDownloading() && downloadRequest(paymentRequest)"
                  (keyup.enter)="!isDownloading() && downloadRequest(paymentRequest)">
                  <i class="fa fa-file-pdf fa-lg"></i>
                </div>
              </span>
            </div>
          }
          @if (paymentRequest.isIncomplete() && requestState.data.application?.raw?.text && !requestState.data.application?.extractMissingDocuments()) {
            <div class="info-card__item info-card__item--wide">
              <span class="info-card__label">{{ 'DOCUMENTS.requests.comment' | translate }}</span>
              <span class="info-card__value">{{ requestState.data.application?.raw?.text }}</span>
            </div>
          }
        </div>
        <!-- Outside the grid: a full-width grid item would keep every auto-fit column open and squeeze the others -->
        @if (paymentRequest.isIncomplete() && requestState.data.application?.extractMissingDocuments()) {
          <myabvv-incomplete-request-info
            class="info-card__missing-docs"
            [documents]="requestState.data.application?.raw?.documents"
            [comment]="requestState.data.application?.raw?.text">
          </myabvv-incomplete-request-info>
        }
      }

      @if (!requestState.data?.paymentRequest && !requestState.loading) {
        <div class="info-card-empty">
          <i class="fa fa-inbox info-card-empty__icon"></i>
          <span>{{ 'RECENT_INFOS.no_data' | translate }}</span>
        </div>
      }

      @if (!requestState.loading) {
        <div class="section-link">
          <a routerLink="/unemployment/requests" class="section-link__btn">
            {{ 'RECENT_INFOS.view_all_requests' | translate }}
            <i class="fa fa-arrow-right"></i>
          </a>
        </div>
      }
    }
  </section>

  <!-- Section: Last Contribution -->
  <section class="info-section">
    <div class="info-section__header">
      <div class="info-section__icon">
        <i class="fa fa-credit-card"></i>
      </div>
      <h3 class="info-section__title">{{ 'RECENT_INFOS.last_contribution' | translate }}</h3>
    </div>

    @if (membershipFeeState$ | async; as feeState) {
      @if (feeState.loading) {
        <myabvv-loader [message]="'GENERAL.busy_loading' | translate"></myabvv-loader>
      }

      @if (feeState.data?.fee && !feeState.loading) {
        <div class="info-card">
          <!--<div class="info-card__item">
            <span class="info-card__label">{{ 'FINANCIAL.payment_date' | translate }}</span>
            <span class="info-card__value">{{ feeState.data.fee.dateOfPaymentDate | date:'dd/MM/yyyy' }}</span>
          </div>-->
          <div class="info-card__item">
            <span class="info-card__label">{{ 'FINANCIAL.contribution_month' | translate }}</span>
            <span class="info-card__value">{{ feeState.data.fee.contributionPeriodFromMonthDate | date:'MM/yyyy' }}</span>
          </div>
          <div class="info-card__item">
            <span class="info-card__label">{{ 'FINANCIAL.central' | translate }}</span>
            <span class="info-card__value">{{ getTranslatedData(feeState.data.fee.raw?.central) }}</span>
          </div>
          <div class="info-card__item">
            <span class="info-card__label">{{ 'FINANCIAL.region' | translate }}</span>
            <span class="info-card__value">{{ getTranslatedData(feeState.data.fee.raw?.region) }}</span>
          </div>
          <div class="info-card__item">
            <span class="info-card__label">{{ 'FINANCIAL.amount' | translate }}</span>
            <span class="info-card__value info-card__value--highlight">{{ getCurrency('E') }} {{ formatContributionAmount(feeState.data.fee.raw?.amountOfContribution) }}</span>
          </div>
        </div>
      }

      @if (!feeState.data?.fee && !feeState.loading) {
        <div class="info-card-empty">
          @if (feeState.data?.hasHiddenPreEuroFees) {
            <i class="fa fa-info-circle info-card-empty__icon"></i>
            <span>{{ 'FINANCIAL.pre_euro_none' | translate }}</span>
          } @else {
            <i class="fa fa-inbox info-card-empty__icon"></i>
            <span>{{ 'RECENT_INFOS.no_data' | translate }}</span>
          }
        </div>
      }

      @if (!feeState.loading) {
        <div class="section-link">
          <a routerLink="/membership/contributions" class="section-link__btn">
            {{ 'RECENT_INFOS.view_all_contributions' | translate }}
            <i class="fa fa-arrow-right"></i>
          </a>
        </div>
      }
    }
  </section>

  <!-- Fixed position popover for missing documents -->
  @if (requestState$ | async; as reqState) {
    @if (isPopoverVisible && reqState.data?.application?.raw?.documents?.length > 0) {
      <div class="recent-infos-popover"
           [style.top.px]="popoverPosition.top"
           [style.left.px]="popoverPosition.left">
        <div class="recent-infos-popover__header">
          <span class="recent-infos-popover__title">{{ 'DOCUMENTS.requests.missing_documents' | translate }}</span>
          <button class="recent-infos-popover__close" (click)="closePopover()" aria-label="Close">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="recent-infos-popover__content">
          @for (document of reqState.data.application.raw.documents; track document) {
            <div class="recent-infos-popover__item">
              <i class="fa fa-file-alt"></i>
              <span [translate]="'DOCUMENTS.requests.document_types.' + document.docType.trim()"></span>
            </div>
          }
        </div>
      </div>
    }
  }
</div>
